import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  changeCastType,
  changeDynamicValue,
  changeGeoValue,
  changeValue,
} from 'modules/queryBuilder/legacyQueryBuilder/actions';
import { EQUALS, IS_SET, IS_NOT_SET } from 'utils/comparatorTypes';
import { EPOCHS_SECS, EPOCHS_MILLIS } from 'constants/castTypes';
import { selectFieldMappingsByType } from 'modules/catalog/collectionBuilder/selectors';
import { isTriggerValueType } from 'modules/queryBuilder/legacyQueryBuilder/utils';
import {
  selectCastType,
  selectComparator,
  selectDistance,
  selectDynamicValue,
  selectFieldType,
  selectValueType,
  selectLocation,
  selectOptionsForField,
  selectShowDynamicFieldToggle,
  selectShowValidations,
  selectCustomDateTextInput,
  selectValue,
  selectCriteriaProperty,
  selectIsClonedData,
  selectDisallowHandlebarsInQuery,
} from 'modules/queryBuilder/legacyQueryBuilder/selectors';
import {
  selectIsMultiSelectInputComparatorsFeatureFlagOn,
  selectIsMultiSelectWithListMembershipFeatureFlagOn,
} from 'core/userContext';
import { BRAND_AFFINITY, EXIT_RULE_ID, LIST_MEMBERSHIP } from 'utils/fieldConstants';
import * as t from 'utils/fieldTypes';
import noop from 'utils/noop';
import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { validateCriteriaValue } from 'modules/queryBuilder/legacyQueryBuilder/helpers';
import { colors } from 'ui/theme/colors';
import { OpenNewWindow24 } from 'ui/icons/action/OpenNewWindow24';
import CriteriaBooleanField from './CriteriaBooleanField';
import CriteriaDateField from './CriteriaDateField';
import CriteriaGeoLocationField from './CriteriaGeoLocationField';
import CriteriaNumberField from './CriteriaNumberField';
import { CriteriaLongField } from './CriteriaLongField';
import CriteriaPropertyOptionsDropdown from './CriteriaPropertyOptionsDropdown';
import CriteriaTextField from './CriteriaTextField';
import CriteriaTypeaheadField from './CriteriaTypeaheadField';
import MultiSelectDropdown from './MultiSelectDropdown';
import SingleSelectDropdown from './SingleSelectDropdown';
import UserMappingsDropdown from './UserMappingsDropdown';
import { getDateDisplayValue, getMultiSelectInputDisplayValue, getViewListLink } from './helpers';
import { BRAND_AFFINITY_OPTIONS, SINGLE_SELECT_FIELDS, MULTI_SELECT_FIELDS } from './constants';
import { MultiSelectInputContextProvider } from './contexts';
import { EXIT_RULE_ID_PLACEHOLDER } from './constants';
import { getIsMultiSelectInput } from './utils';
// import { DynamicValue } from './types';
import {
  ViewListLink,
  ReadOnlyLabel,
  InputContainer,
  SetField,
} from './CriteriaPropertyField.styled';
import { MultiSelectInput } from './MultiSelectInput';

export const VIEW_LIST_LINK_TEST_ID = 'view-emailListIds-link';

// type Props = {
//   /** The castType of the criteria property. */
//   castType: string,
//   /** The currently selected comparator. */
//   comparator: string,
//   /** The index of this criteria property. */
//   criteriaPropertyIndex: number,
//   /** If the field is disabled. */
//   disabled: boolean,
//   /** The distance object of geo query. */
//   distance: {},
//   /** The dynamic value of the criteria property. */
//   dynamicValue: DynamicValue,
//   /** The field of the criteria property. */
//   field: string,
//   /** The field type of the criteria property. */
//   fieldType: string,
//   /** read only view prop */
//   isReadOnly?: boolean,
//   /** The source type of the value */
//   valueType: boolean,
//   /** The location object of geo query. */
//   location: {},
//   /**
//    * Callback function when the criteria value changes.
//    */
//   onChangeValue: () => {},
//   /**
//    * Callback function when the criteria dynamic value changes.
//    */
//   onChangeDynamicValue: () => {},
//   /**
//    * Callback function when the criteria geo value changes.
//    *
//    * ```
//    * onChangeGeoValue(lat, long, distance, unit, groupIndex, queryIndex, criteriaIndex) => {}
//    * ```
//    * @param { Number } lat: The latitude value.
//    * @param { Number } long: The longitude value.
//    * @param { Number } distance: The distance value.
//    * @param { String } unit: The distance unit.
//    * @param { Number } groupIndex: The index of the search group.
//    * @param { Number } queryIndex: The index of the search query group.
//    * @param { Number } criteriaIndex: The index of the criteria property group.
//    * @returns { void }
//    */
//   onChangeGeoValue: () => {},
//   /**
//    * Callback function when the criteria value changes.
//    */
//   onChangeValue: () => {},
//   /** Specified field options. */
//   options: [],
//   /** The index of the search group this criteria property is in. */
//   searchGroupIndex: number,
//   /** The index of the search query this criteria property is in. */
//   searchQueryIndex: number,
//   /** Show custom date text input */
//   showCustomDateTextInput: boolean,
//   /** If validations are shown. */
//   showValidations: boolean,
//   /** Whether or not to display a cast type field for specific Long type criteria property fields */
//   useCastTypeField: boolean,
//   /** Object comtaining lists of user mappings by type. */
//   userMappings: {},
//   /** The value of the criteria property. */
//   value: string,
//   /** Whether or not to show an autofill input */
//   canUseValueTypeahead: boolean,
//   /** Whether or not handlebars are allowed in the field */
//   disallowHandlebarsInQuery?: boolean,
// };

class CriteriaPropertyField extends React.Component {
  static defaultProps = {
    comparator: EQUALS,
    fieldType: t.STRING,
    onChangeValue: noop,
    options: [],
    userMappings: {},
    value: '',
    disabled: false,
    isReadOnly: false,
    isMultiSelectInputAllowed: false,
  };

  renderGeoField = (commonProps) => {
    const { distance, location, onChangeGeoValue } = this.props;
    return (
      <CriteriaGeoLocationField
        {...commonProps}
        distance={distance}
        location={location}
        onChange={onChangeGeoValue}
      />
    );
  };

  renderUserMappingsDropdown = (commonProps) => {
    const { dynamicValue, fieldType, onChangeDynamicValue, userMappings } = this.props;
    return (
      <UserMappingsDropdown
        {...commonProps}
        options={userMappings[fieldType]}
        onChange={onChangeDynamicValue}
        placeholder={'Select a Contact Property'}
        value={dynamicValue}
      />
    );
  };

  getValidationErrors = () => {
    const { criteriaProperty, disallowHandlebarsInQuery } = this.props;
    const errors = {};
    if (criteriaProperty)
      validateCriteriaValue(cloneDeep(criteriaProperty), errors, disallowHandlebarsInQuery);
    return Object.values(errors);
  };

  renderValueField = () => {
    const {
      castType,
      comparator,
      criteriaPropertyIndex,
      disabled,
      dynamicValue,
      field,
      fieldType,
      isReadOnly,
      onChangeCastType,
      onChangeDynamicValue,
      onChangeValue,
      options,
      searchGroupIndex,
      searchQueryIndex,
      showValidations,
      showCustomDateTextInput,
      useCastTypeField,
      value,
      values,
      valueType,
      isClonedData,
      type,
    } = this.props;

    const validationErrors = this.getValidationErrors();
    const defaultPlaceholder = field === EXIT_RULE_ID ? EXIT_RULE_ID_PLACEHOLDER : 'value';
    const commonProps = {
      type,
      disabled: disabled || isReadOnly,
      error: (showValidations && validationErrors) || (isClonedData && !values?.length),
      fieldIdentifier: [searchGroupIndex, searchQueryIndex, criteriaPropertyIndex],
      onChange: onChangeValue,
      placeholder: disabled ? '' : defaultPlaceholder,
      value,
    };
    const isMultiSelectInput = getIsMultiSelectInput(this.props);
    let input = {};
    let displayValue = value;

    if (comparator === IS_SET || comparator === IS_NOT_SET) {
      return {
        input: <SetField data-test="criteria-comparator" />,
        displayValue: '',
      };
    }

    if (isMultiSelectInput) {
      input = (
        <MultiSelectInputContextProvider>
          <MultiSelectInput valueType={valueType} isReadOnly={isReadOnly} />
        </MultiSelectInputContextProvider>
      );
      displayValue = getMultiSelectInputDisplayValue(values);
    } else if (MULTI_SELECT_FIELDS.includes(field)) {
      input = (
        <MultiSelectDropdown
          {...commonProps}
          isReadOnly={isReadOnly}
          field={field}
          values={values}
        />
      );
    } else if (SINGLE_SELECT_FIELDS.includes(field)) {
      const defaultOptions = field === BRAND_AFFINITY ? BRAND_AFFINITY_OPTIONS : [];
      const shouldShowViewListLink = field === LIST_MEMBERSHIP && value;
      input = (
        <>
          <SingleSelectDropdown
            {...commonProps}
            defaultOptions={defaultOptions}
            field={field}
            isReadOnly={isReadOnly}
          />
          {shouldShowViewListLink && (
            <ViewListLink
              target="_blank"
              href={getViewListLink(value)}
              rel="noreferrer noopener"
              data-test={VIEW_LIST_LINK_TEST_ID}
            >
              View <OpenNewWindow24 color={colors.textLink} height={20} />
            </ViewListLink>
          )}
        </>
      );
    } else if (valueType !== ValueType.Custom) {
      const triggerFieldInput = (
        <CriteriaTextField {...commonProps} onChange={onChangeDynamicValue} value={dynamicValue} />
      );
      input = isTriggerValueType(valueType)
        ? triggerFieldInput
        : this.renderUserMappingsDropdown(commonProps);
      switch (fieldType) {
        case t.GEO_LOCATION:
          input = this.renderGeoField({
            ...commonProps,
            content: input,
            hideLocationPicker: true,
          });
          break;
        default:
          displayValue = dynamicValue;
      }
    } else if (options && options.length) {
      input = <CriteriaPropertyOptionsDropdown {...commonProps} />;
    } else {
      switch (fieldType) {
        case t.BOOLEAN:
          input = <CriteriaBooleanField {...commonProps} />;
          break;
        case t.DATE:
          input = (
            <CriteriaDateField {...commonProps} showCustomDateTextInput={showCustomDateTextInput} />
          );
          displayValue = getDateDisplayValue(value);
          break;
        case t.GEO_LOCATION:
          input = this.renderGeoField(commonProps);
          break;
        case t.DOUBLE:
          input = <CriteriaNumberField allowDecimal {...commonProps} isReadOnly={isReadOnly} />;
          break;
        case t.LONG:
          if (useCastTypeField) {
            if (castType === EPOCHS_SECS || castType === EPOCHS_MILLIS) {
              // if cast type is EpochSecs or EpochMillis, provide a date picker
              input = (
                <CriteriaDateField
                  {...commonProps}
                  castType={castType}
                  onChangeCastType={onChangeCastType}
                />
              );
            } else {
              input = (
                <CriteriaLongField
                  {...commonProps}
                  castType={castType}
                  onChangeCastType={onChangeCastType}
                />
              );
            }
          } else {
            input = <CriteriaNumberField {...commonProps} />;
          }
          break;
        case t.STRING:
        default:
          input = <CriteriaTypeaheadField {...commonProps} isReadOnly={isReadOnly} />;
      }
    }
    return { input, displayValue };
  };

  render() {
    const { fieldType } = this.props;
    const { displayValue, input } = this.renderValueField();
    const isMultiSelectInput = getIsMultiSelectInput(this.props);

    return (
      <>
        <ReadOnlyLabel>{displayValue}</ReadOnlyLabel>
        <InputContainer
          data-isGeoField={fieldType === t.GEO_LOCATION}
          data-isMultiSelectInput={isMultiSelectInput}
        >
          {input}
        </InputContainer>
      </>
    );
  }
}

export { CriteriaPropertyField as CriteriaPropertyFieldComponent };

const mapStateToProps = (state, props) => ({
  castType: selectCastType(state, props),
  comparator: selectComparator(state, props),
  distance: selectDistance(state, props),
  dynamicValue: selectDynamicValue(state, props),
  fieldType: selectFieldType(state, props),
  location: selectLocation(state, props),
  options: selectOptionsForField(state, props),
  showDynamicFieldToggle: selectShowDynamicFieldToggle(state),
  showValidations: selectShowValidations(state),
  showCustomDateTextInput: selectCustomDateTextInput(state),
  userMappings: selectFieldMappingsByType(state),
  value: selectValue(state, props),
  isMultiSelectInputAllowed: selectIsMultiSelectInputComparatorsFeatureFlagOn(state),
  isMultiSelectWithListMembershipAllowed: selectIsMultiSelectWithListMembershipFeatureFlagOn(state),
  valueType: selectValueType(state, props),
  isClonedData: selectIsClonedData(state, props),
  criteriaProperty: selectCriteriaProperty(state, props),
  disallowHandlebarsInQuery: selectDisallowHandlebarsInQuery(state, props),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onChangeCastType: changeCastType,
      onChangeDynamicValue: changeDynamicValue,
      onChangeGeoValue: changeGeoValue,
      onChangeValue: changeValue,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CriteriaPropertyField);
